import { LocalStorage } from "@savagebull/common";

const storage = new LocalStorage("ba-scoring-app");

export default storage;
